import { ExtraService } from '../../services/extra/extra.service'
import { NavController } from '@ionic/angular'
import { AlertService } from '../../services/alert/alert.service'
import { IGroup, GroupService } from 'src/app/services/group/group.service'
import { IUser, UserService } from 'src/app/services/user/user.service'
import { Component, OnDestroy } from '@angular/core'
import { LoadingController } from '@ionic/angular'
import { ImageService } from './../../services/image/image.service'
import { DEFAULT_BACKGROUND_COLOR } from 'src/app/config'

@Component({
  selector: 'app-group',
  templateUrl: './group.page.html',
  styleUrls: ['./group.page.scss'],
})
export class GroupPage implements OnDestroy {

  user: IUser = null
  userSubscription: any

  groupList: IGroup[] = []
  groupListSubscription: any

  search = ''

  backgroundImageStyle: string
  backgroundImagePathSubscription: any

  constructor(
    private userService: UserService,
    private extraService: ExtraService,
    private groupService: GroupService,
    private alert: AlertService,
    private navCtrl: NavController,
    private loadingController: LoadingController,

    private imgService: ImageService,
  ) {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
    this.groupListSubscription = this.groupService.groupList.subscribe(value => this.groupList = value)

    this.backgroundImagePathSubscription = this.imgService.appBackground.subscribe(value => {
      const url = this.imgService.urlPathForImage(value)
      if (url && url !== '')
        this.backgroundImageStyle = `url(${url}) no-repeat center/cover fixed`
      else
        this.backgroundImageStyle = DEFAULT_BACKGROUND_COLOR
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.groupListSubscription.unsubscribe()
  }

  update() {
    this.loadingController.create({
      message: 'Wird geladen',
      showBackdrop: false
    })
      .then(loading => loading.present()
        .then(() => this.extraService.updateAllLists(this.user.token, this.user.id))
        .catch((err) => this.alert.errorHandler(err, 'Fehler beim Aktualizieren von Daten!'))
        .then(() => loading.dismiss())
      )
  }

  ionViewWillEnter() {
    this.update()
  }

  gotoGroupDetails(group: IGroup) {
    this.navCtrl.navigateForward(`/group-details/${group.id}`)
  }

  gotoGroupNew() {
    this.alert.inputPrompt([{ placeholder: 'Gruppenname', name: 'groupName' }], 'Neue Gruppe erstellen')
      .then(result => {
        if (result)
          return this.groupService.addGroup(this.user.token, result['groupName'])
            .then(() => this.update())
      })
      .catch((err) => this.alert.errorHandler(err))
  }

  trackByFn(index, item) {
    return item.id
  }

  isVisible(group: IGroup) {
    return group.name.toLowerCase().search(this.search.toLowerCase()) !== -1
  }

  /* gotoProfile() {
    this.navCtrl.navigateForward('/profile')
  } */

  goBack() {
    return this.navCtrl.navigateRoot('/', { animated: true, animationDirection: 'back' })
  }
}
